const getFilesReport = state => state.filesReport;

const getOrdersReport = state => state.ordersReport;

const getCountReportFiles = state => state.countReportFiles;

const getCountReportOrders = state => state.countReportOrders;

const getPickupsReport = state => state.pickupsReport;

const getDigitalizationReport = state => state.digitalizationReport;

export default {
  getFilesReport,
  getOrdersReport,
  getCountReportFiles,
  getCountReportOrders,
  getPickupsReport,
  getDigitalizationReport
};



// WEBPACK FOOTER //
// ./src/store/modules/reports/getters.js